<script lang="ts">
  import { useSubscriptionConfig } from '@/utils/use-subscription-config.svelte';

  import LoginCard from './cmps/LoginCard.svelte';
  import LoginForm from './cmps/LoginForm.svelte';

  const config = useSubscriptionConfig();

  const { data, error, loading } = $derived(config.current);
</script>

<LoginCard customerLogo={data?.customer_logo}>
  {#if loading}
    <div>Loading...</div>
  {/if}

  {#if error}
    <div class="flex flex-col items-center gap-3">
      <h1 class="text-[20px] font-bold text-c-error">Fehler:</h1>
      <p class="text-lg">{error.message}</p>
    </div>
  {/if}

  {#if data && !loading}
    <LoginForm config={data} />
  {/if}
</LoginCard>
